(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitment-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {

  var SHEET_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSWdzU4ZvalSpop-KcUrGn93TowzFBQjALC2gE5zXUtMl7sAI8ROg6zToUUNrN6eOLAeI9Ko7SfmWb3/pub?output=csv';

  function parseStatus(raw) {
    var s = (raw || '').trim().toLowerCase();
    if (s === 'fits' || s === 'fit') return 'fit';
    if (s === 'does not fit' || s === 'no' || s === 'no-fit' || s === 'not compatible') return 'no-fit';
    return 'untested';
  }

  function parseCSV(text) {
    var rows = [], current = [], field = '', inQ = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (inQ) {
        if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
        else if (c === '"') { inQ = false; }
        else { field += c; }
      } else {
        if      (c === '"')  { inQ = true; }
        else if (c === ',')  { current.push(field); field = ''; }
        else if (c === '\n') { current.push(field); rows.push(current); current = []; field = ''; }
        else if (c !== '\r') { field += c; }
      }
    }
    if (field.length || current.length) { current.push(field); rows.push(current); }
    return rows;
  }

  var SKIP_WORDS = ['manufacture', 'manufacturer', 'brand', 'north america',
                    'gas pole saws', 'electric', 'hydolic', 'hydraulic', 'new'];

  function isSkipRow(row) {
    var a = (row[0] || '').trim().toLowerCase();
    var b = (row[1] || '').trim().toLowerCase();
    if (!a && !b) return true;
    if (SKIP_WORDS.indexOf(a) !== -1) return true;
    if (!b) return true;
    return false;
  }

  function buildData(rows) {
    var map = {};
    rows.forEach(function (row) {
      if (row.length < 2) return;
      if (isSkipRow(row)) return;
      var brand     = (row[0] || '').trim();
      var model     = (row[1] || '').trim();
      var rawStatus = (row[2] || row[3] || '').trim();
      if (!brand || !model) return;
      if (!map[brand]) map[brand] = [];
      map[brand].push({ model: model, status: parseStatus(rawStatus) });
    });
    return map;
  }

  function setup(root) {
    var errorEl    = root.querySelector('[data-tfc-error]');
    var errorMsg   = root.querySelector('[data-tfc-error-msg]');
    var brandSel   = root.querySelector('[data-tfc-brand]');
    var modelSel   = root.querySelector('[data-tfc-model]');
    var resultEl   = root.querySelector('[data-tfc-result]');
    var brandsWrap = root.querySelector('[data-tfc-brands]');
    var brandsList = root.querySelector('[data-tfc-brands-list]');
    var data       = {};

    function showError(msg) {
      errorEl.hidden = false;
      errorMsg.textContent = msg;
      brandSel.innerHTML = '<option value="">Unavailable</option>';
    }

    function clearResult() {
      resultEl.hidden    = true;
      resultEl.innerHTML = '';
      resultEl.className = 'tfc-result';
    }

    function showResult(type, title, body) {
      var icons = { fit: '\u2713', 'no-fit': '\u2715', untested: '?' };
      resultEl.hidden    = false;
      resultEl.className = 'tfc-result tfc-result--' + type;
      resultEl.innerHTML =
        '<div class="tfc-result__icon" aria-hidden="true">' + icons[type] + '</div>' +
        '<div>' +
          '<p class="tfc-result__title">' + title + '</p>' +
          '<p class="tfc-result__body">'  + body  + '</p>' +
        '</div>';
    }

    // Only brands that have at least one "fit" model are shown/listed.
    function sortedBrands(data, onlyCompatible) {
      return Object.keys(data)
        .filter(function (b) {
          if (!onlyCompatible) return true;
          return data[b].some(function (entry) { return entry.status === 'fit'; });
        })
        .sort(function (a, b) {
          return a.localeCompare(b, undefined, { sensitivity: 'base' });
        });
    }

    function populateBrands(data) {
      brandSel.innerHTML = '<option value="">Select brand...</option>';
      sortedBrands(data, true).forEach(function (b) {
        var opt = document.createElement('option');
        opt.value = b;
        opt.textContent = b;
        brandSel.appendChild(opt);
      });
      brandSel.disabled = false;
    }

    function populateBrandChips(data) {
      if (!brandsWrap || !brandsList) return;
      brandsList.innerHTML = '';
      sortedBrands(data, true).forEach(function (b) {
        var li = document.createElement('li');
        li.textContent = b;
        brandsList.appendChild(li);
      });
      brandsWrap.hidden = false;
    }

    brandSel.addEventListener('change', function () {
      var brand = brandSel.value;
      modelSel.innerHTML = '';
      clearResult();

      if (!brand) {
        var def = document.createElement('option');
        def.value = '';
        def.textContent = 'Select brand first...';
        modelSel.appendChild(def);
        modelSel.disabled = true;
        return;
      }

      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select model...';
      modelSel.appendChild(placeholder);

      (data[brand] || []).forEach(function (entry) {
        var opt = document.createElement('option');
        opt.value = entry.model;
        opt.dataset.status = entry.status;
        opt.textContent = entry.model;
        modelSel.appendChild(opt);
      });

      modelSel.disabled = false;
    });

    modelSel.addEventListener('change', function () {
      var selected = modelSel.options[modelSel.selectedIndex];
      if (!selected || !selected.value) { clearResult(); return; }

      var brand  = brandSel.value;
      var model  = selected.value;
      var status = selected.dataset.status;

      if (status === 'fit') {
        showResult('fit', 'Compatible',
          'The TIMBAR\u2122 Universal Bar is confirmed to fit the ' + brand + ' ' + model + '.');
      } else if (status === 'no-fit') {
        showResult('no-fit', 'Not compatible',
          'The TIMBAR\u2122 Universal Bar does not fit the ' + brand + ' ' + model + '. Contact us and we\'ll help find the right fit.');
      } else {
        showResult('untested', 'Not yet tested',
          'We haven\'t confirmed compatibility with the ' + brand + ' ' + model + ' yet. Contact us and our team will check it for you.');
      }
    });

    fetch(SHEET_CSV_URL)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var rows = parseCSV(text);
        data = buildData(rows);
        if (Object.keys(data).length === 0) {
          showError('No compatibility data found. Make sure the sheet is published correctly.');
          return;
        }
        if (sortedBrands(data, true).length === 0) {
          showError('No compatible brands found in the data yet.');
          return;
        }
        populateBrands(data);
        populateBrandChips(data);
      })
      .catch(function (err) {
        showError('Could not load compatibility data. Please refresh the page.');
        if (window.console) console.error('[TIMBAR fitment]', err);
      });
  }

  document.querySelectorAll('[data-tfc]').forEach(setup);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timbar-fitment-cal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var sheetUrl      = root.dataset.sheetUrl;
      var productHandle = (root.dataset.productHandle || '').toLowerCase();

      var loadingEl   = root.querySelector('[data-loading]');
      var errorEl     = root.querySelector('[data-error]');
      var bodyEl      = root.querySelector('[data-body]');
      var resultEl    = root.querySelector('[data-result]');

      var modesEl     = root.querySelector('[data-modes]');
      var restartBtn  = root.querySelector('[data-action="restart"]');
      var modeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mode-btn]'));
      var panels      = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));

      var brandSelect = root.querySelector('[data-field="brand"]');
      var modelSelect = root.querySelector('[data-field="model"]');
      var specsButton = root.querySelector('[data-action="check-specs"]');

      // pageMode: 'product' = check the current product, 'finder' = list matching products
      var pageMode     = productHandle ? 'product' : 'finder';
      var method       = null;   // 'model' | 'specs' | null (still on the chooser screen)
      var singleMethod = false;  // true when only one method is usable (no saw-model data)

      var allRows  = [];   // every row from the CSV
      var compat   = null; // only set in product mode — the specs THIS product supports
      var brandMap = {};   // brand -> [{ model, raw }]

      // ── UI state helpers ─────────────────────────────────────────────────
      function showError(msg) {
        loadingEl.hidden = true;
        bodyEl.hidden = true;
        errorEl.hidden = false;
        errorEl.textContent = msg;
      }
      function showBody() {
        loadingEl.hidden = true;
        errorEl.hidden = true;
        bodyEl.hidden = false;
      }
      function hideResult() {
        resultEl.hidden = true;
        resultEl.innerHTML = '';
        resultEl.className = 'fitment-calc__result';
      }
      function showResult(type, msg) {
        resultEl.innerHTML = '';
        resultEl.textContent = msg;
        resultEl.hidden = false;
        resultEl.className = 'fitment-calc__result fitment-calc__result--' + type;
      }

      // ── CSV parsing ──────────────────────────────────────────────────────
      function parseCSV(text) {
        var rows = [], current = [], field = '', inQuotes = false;
        for (var i = 0; i < text.length; i++) {
          var c = text.charAt(i);
          if (inQuotes) {
            if (c === '"' && text.charAt(i + 1) === '"') { field += '"'; i++; }
            else if (c === '"') { inQuotes = false; }
            else { field += c; }
          } else {
            if (c === '"') { inQuotes = true; }
            else if (c === ',') { current.push(field); field = ''; }
            else if (c === '\n') { current.push(field); rows.push(current); current = []; field = ''; }
            else if (c === '\r') { /* skip CR */ }
            else { field += c; }
          }
        }
        if (field.length || current.length) { current.push(field); rows.push(current); }
        return rows;
      }

      function parseSheet(text) {
        var rows = parseCSV(text);
        if (rows.length < 2) return [];
        var headers = rows[0].map(function (h) {
          return h.trim().toLowerCase().replace(/\s+/g, '_');
        });
        return rows.slice(1)
          .filter(function (row) { return row.some(function (c) { return c && c.trim(); }); })
          .map(function (row) {
            var obj = {};
            headers.forEach(function (h, i) { obj[h] = (row[i] || '').trim(); });
            return obj;
          });
      }

      function splitList(value) {
        return (value || '').split(/;/).map(function (s) { return s.trim(); }).filter(Boolean);
      }
      function unionInto(target, values) {
        values.forEach(function (v) { if (target.indexOf(v) === -1) target.push(v); });
      }

      // ── Compatibility for the current product (product mode only) ─────────
      function buildCompatibility(rows) {
        var matching = rows.filter(function (r) {
          return (r.product_handle || '').toLowerCase() === productHandle;
        });
        if (matching.length === 0) return null;
        var result = { bar_lengths: [], pitches: [], gauges: [], tool_heads: [] };
        matching.forEach(function (row) {
          unionInto(result.bar_lengths, splitList(row.bar_lengths));
          unionInto(result.pitches,     splitList(row.pitches));
          unionInto(result.gauges,      splitList(row.gauges));
          unionInto(result.tool_heads,  splitList(row.tool_heads));
        });
        return result;
      }

      // ── Brand / model menus (Option 1) ───────────────────────────────────
      // First word of a tool_head is the brand; the rest is the model.
      // Use "Brand|Model" in the CSV for explicit control (e.g. multi-word brands).
      function parseToolHead(raw) {
        raw = (raw || '').trim();
        if (!raw) return null;
        var brand, model;
        if (raw.indexOf('|') !== -1) {
          var parts = raw.split('|');
          brand = parts[0].trim();
          model = parts.slice(1).join('|').trim() || brand;
        } else {
          var sp = raw.indexOf(' ');
          if (sp === -1) { brand = raw; model = raw; }
          else { brand = raw.slice(0, sp).trim(); model = raw.slice(sp + 1).trim(); }
        }
        // `raw` stays exactly as written in the CSV, so matching is exact.
        return { brand: brand, model: model, raw: raw };
      }

      function buildBrandMap(rows) {
        var map = {};
        rows.forEach(function (row) {
          splitList(row.tool_heads).forEach(function (entry) {
            var p = parseToolHead(entry);
            if (!p) return;
            if (!map[p.brand]) map[p.brand] = [];
            var exists = map[p.brand].some(function (m) { return m.raw === p.raw; });
            if (!exists) map[p.brand].push({ model: p.model, raw: p.raw });
          });
        });
        Object.keys(map).forEach(function (b) {
          map[b].sort(function (a, c) {
            return a.model.localeCompare(c.model, undefined, { numeric: true });
          });
        });
        return map;
      }

      function populateBrands() {
        var brands = Object.keys(brandMap).sort(function (a, b) {
          return a.localeCompare(b, undefined, { sensitivity: 'base' });
        });
        brands.forEach(function (b) {
          var opt = document.createElement('option');
          opt.value = b;
          opt.textContent = b;
          brandSelect.appendChild(opt);
        });
        return brands.length;
      }

      function onBrandChange() {
        var brand = brandSelect.value;
        modelSelect.innerHTML = '';
        var def = document.createElement('option');
        def.value = '';

        if (!brand) {
          def.textContent = 'Choose a brand first…';
          modelSelect.appendChild(def);
          modelSelect.disabled = true;
          hideResult();
          return;
        }

        def.textContent = 'Select model…';
        modelSelect.appendChild(def);
        (brandMap[brand] || []).forEach(function (m) {
          var opt = document.createElement('option');
          opt.value = m.raw;        // exact CSV value
          opt.textContent = m.model;
          modelSelect.appendChild(opt);
        });
        modelSelect.disabled = false;
        hideResult();
      }

      function onModelChange() {
        var raw = modelSelect.value;
        if (!raw) { hideResult(); return; }
        if (pageMode === 'product') checkProductByModel(raw);
        else findByModel(raw);
      }

      // ── Result builders: by model ─────────────────────────────────────────
      function modelLabel(raw) {
        var p = parseToolHead(raw);
        return p ? (p.brand + ' ' + p.model).trim() : raw;
      }

      function checkProductByModel(raw) {
        if (!compat) return;
        if (compat.tool_heads.indexOf(raw) !== -1) {
          showResult('fit', '\u2713 Yes — this product fits the ' + modelLabel(raw) + '.');
        } else {
          var lines = ['This product is not listed as a fit for the ' + modelLabel(raw) + '.'];
          if (compat.tool_heads.length) {
            lines.push('It fits: ' + compat.tool_heads.map(modelLabel).join(', '));
          }
          showResult('no-fit', '\u2717 ' + lines.join('\n'));
        }
      }

      function findByModel(raw) {
        var handles = [];
        allRows.forEach(function (row) {
          if (splitList(row.tool_heads).indexOf(raw) !== -1) {
            var h = (row.product_handle || '').trim();
            if (h && handles.indexOf(h) === -1) handles.push(h);
          }
        });
        renderProductList(handles, 'that fit the ' + modelLabel(raw));
      }

      // ── Result builders: by specs (Option 2) ─────────────────────────────
      function checkProductBySpecs(length, pitch, gauge) {
        if (!compat) return;
        var lengthOk = compat.bar_lengths.indexOf(length) !== -1;
        var pitchOk  = compat.pitches.indexOf(pitch)      !== -1;
        var gaugeOk  = compat.gauges.indexOf(gauge)       !== -1;

        if (lengthOk && pitchOk && gaugeOk) {
          showResult('fit', '\u2713 This product fits a ' + length + '" bar, ' + pitch + ' pitch, ' + gauge + ' gauge.');
          return;
        }

        var issues = [];
        if (!lengthOk) issues.push(length + '" bar length');
        if (!pitchOk)  issues.push(pitch + ' pitch');
        if (!gaugeOk)  issues.push(gauge + ' gauge');

        var lines = ['This product is not compatible with: ' + issues.join(', ') + '.'];
        lines.push('Compatible bar lengths: ' + compat.bar_lengths.map(function (l) { return l + '"'; }).join(', '));
        lines.push('Compatible pitches: '     + compat.pitches.join(', '));
        lines.push('Compatible gauges: '      + compat.gauges.join(', '));
        showResult('no-fit', '\u2717 ' + lines.join('\n'));
      }

      function findBySpecs(length, pitch, gauge) {
        var handles = [];
        allRows.forEach(function (row) {
          if (splitList(row.bar_lengths).indexOf(length) !== -1 &&
              splitList(row.pitches).indexOf(pitch)      !== -1 &&
              splitList(row.gauges).indexOf(gauge)       !== -1) {
            var h = (row.product_handle || '').trim();
            if (h && handles.indexOf(h) === -1) handles.push(h);
          }
        });
        renderProductList(handles, 'that match a ' + length + '" bar, ' + pitch + ' pitch, ' + gauge + ' gauge');
      }

      // ── Product list (finder mode) ────────────────────────────────────────
      function formatPrice(cents) {
        if (typeof cents !== 'number') return '';
        return '$' + (cents / 100).toFixed(2);
      }

      function renderProductList(handles, descriptor) {
        hideResult();
        resultEl.hidden = false;
        resultEl.className = 'fitment-calc__result fitment-calc__result--finder';

        if (handles.length === 0) {
          var none = document.createElement('div');
          none.className = 'fitment-calc__no-matches';
          none.textContent = '\u2717 No products match your selection. Try a different combination, or contact us and we’ll help you find the right fit.';
          resultEl.appendChild(none);
          return;
        }

        var heading = document.createElement('div');
        heading.className = 'fitment-calc__finder-heading';
        heading.textContent = '\u2713 ' + handles.length + ' product' + (handles.length === 1 ? '' : 's') + ' ' + descriptor + ':';
        resultEl.appendChild(heading);

        var list = document.createElement('div');
        list.className = 'fitment-calc__product-list';
        resultEl.appendChild(list);

        var MAX_DISPLAYED = 24;
        handles.slice(0, MAX_DISPLAYED).forEach(function (handle) {
          var card = document.createElement('a');
          card.className = 'fitment-calc__product-card';
          card.href = '/products/' + handle;

          var info = document.createElement('div');
          info.className = 'fitment-calc__product-info';
          var title = document.createElement('div');
          title.className = 'fitment-calc__product-title';
          title.textContent = handle; // fallback until JSON loads
          info.appendChild(title);
          card.appendChild(info);
          list.appendChild(card);

          fetch('/products/' + encodeURIComponent(handle) + '.js')
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then(function (product) {
              card.innerHTML = '';
              if (product.featured_image) {
                var img = document.createElement('img');
                img.src = product.featured_image;
                img.alt = '';
                img.className = 'fitment-calc__product-image';
                img.loading = 'lazy';
                card.appendChild(img);
              }
              var info2 = document.createElement('div');
              info2.className = 'fitment-calc__product-info';
              var title2 = document.createElement('div');
              title2.className = 'fitment-calc__product-title';
              title2.textContent = product.title || handle;
              info2.appendChild(title2);
              if (typeof product.price === 'number') {
                var price = document.createElement('div');
                price.className = 'fitment-calc__product-price';
                price.textContent = formatPrice(product.price);
                info2.appendChild(price);
              }
              card.appendChild(info2);
            })
            .catch(function () { /* keep the handle fallback */ });
        });

        if (handles.length > MAX_DISPLAYED) {
          var more = document.createElement('div');
          more.style.marginTop = '0.5rem';
          more.style.fontSize = '0.85rem';
          more.style.opacity = '0.7';
          more.textContent = '…and ' + (handles.length - MAX_DISPLAYED) + ' more.';
          resultEl.appendChild(more);
        }
      }

      // ── Specs submit ──────────────────────────────────────────────────────
      function checkSpecs() {
        var length = root.querySelector('[data-field="length"]').value;
        var pitch  = root.querySelector('[data-field="pitch"]').value;
        var gauge  = root.querySelector('[data-field="gauge"]').value;

        if (!length || !pitch || !gauge) {
          showResult('partial', 'Select a bar length, chain pitch, and chain gauge to check fitment.');
          return;
        }
        if (pageMode === 'product') checkProductBySpecs(length, pitch, gauge);
        else findBySpecs(length, pitch, gauge);
      }

      // ── Mode switching ────────────────────────────────────────────────────
      // Two states: the chooser (both buttons) and an active method (one button,
      // centered, with "Start over" available to return to the chooser).
      function goToChoose(focus) {
        method = null;
        modesEl.classList.add('fitment-calc__modes--choose');
        modesEl.classList.remove('fitment-calc__modes--active');
        modeButtons.forEach(function (btn) {
          btn.hidden = btn.disabled;           // show every option that's usable
          btn.classList.remove('is-active');
        });
        panels.forEach(function (p) { p.hidden = true; });
        if (restartBtn) restartBtn.hidden = true;
        hideResult();
        if (focus) {
          var first = modeButtons.filter(function (b) { return !b.disabled; })[0];
          if (first) first.focus();
        }
      }

      function selectMethod(next, focus) {
        method = next;
        modesEl.classList.remove('fitment-calc__modes--choose');
        modesEl.classList.add('fitment-calc__modes--active');
        modeButtons.forEach(function (btn) {
          var active = btn.dataset.modeBtn === next;
          btn.hidden = !active;                // only the chosen button stays, centered
          btn.classList.toggle('is-active', active);
        });
        panels.forEach(function (p) { p.hidden = p.dataset.panel !== next; });
        if (restartBtn) restartBtn.hidden = singleMethod;
        hideResult();
        if (focus) {
          var panel = panels.filter(function (p) { return p.dataset.panel === next; })[0];
          if (panel) panel.focus();
        }
      }

      // ── Init ──────────────────────────────────────────────────────────────
      function init() {
        if (!sheetUrl) {
          showError('Fitment data file not found. Upload fitment-data.csv to your theme assets.');
          return;
        }

        fetch(sheetUrl)
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (text) {
            allRows = parseSheet(text);
            if (allRows.length === 0) {
              showError('No fitment data found in the CSV. Check that the file has the required column headers.');
              return;
            }

            if (pageMode === 'product') {
              compat = buildCompatibility(allRows);
              if (!compat) {
                showError('Fitment data isn’t available for this product yet. Contact us if you need help confirming compatibility.');
                return;
              }
            }

            brandMap = buildBrandMap(allRows);
            var brandCount = populateBrands();

            // If the CSV has no saw-model data, there's only one usable path:
            // disable the model option and open the specs panel directly.
            if (brandCount === 0) {
              var modelBtn = root.querySelector('[data-mode-btn="model"]');
              if (modelBtn) modelBtn.disabled = true;
              singleMethod = true;
              selectMethod('specs', false);
            } else {
              goToChoose(false);   // show both buttons to start
            }

            showBody();
          })
          .catch(function (err) {
            showError('Couldn’t load compatibility data. Refresh the page or contact us.');
            if (window.console && console.error) console.error('Fitment calculator:', err);
          });
      }

      // ── Wire up events ────────────────────────────────────────────────────
      modeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          selectMethod(btn.dataset.modeBtn, true);
        });
      });

      if (restartBtn) {
        restartBtn.addEventListener('click', function () { goToChoose(true); });
      }

      if (brandSelect) brandSelect.addEventListener('change', onBrandChange);
      if (modelSelect) modelSelect.addEventListener('change', onModelChange);
      if (specsButton) specsButton.addEventListener('click', checkSpecs);

      root.querySelectorAll('[data-panel="specs"] select').forEach(function (sel) {
        sel.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); checkSpecs(); }
        });
      });

      init();
    }

    function boot() {
      document.querySelectorAll('[data-fitment-calc]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
